import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'bootstrap-4-react/lib/components';

// Modal that collects a required rejection reason before calling reject_signup.
const RejectReasonModal = ({ show, item, loading, onCancel, onConfirm }) => {
    const [reason, setReason] = useState('');

    // Reset the textarea whenever a fresh item is opened so the previous
    // rejection's text doesn't leak across rows.
    useEffect(() => {
        if (show) setReason(item?.RejectionReason || '');
    }, [show, item]);

    const trimmedReason = reason.trim();
    const canSubmit = trimmedReason.length > 0 && !loading;

    const handleConfirm = () => {
        if (!canSubmit) return;
        onConfirm(trimmedReason);
    };

    return (
        <Dialog
            open={!!show}
            onClose={loading ? undefined : onCancel}
            aria-labelledby="reject-onboarding-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="reject-onboarding-title">Reject Onboarding Request</DialogTitle>
            <DialogContent dividers>
                <label className="labelHead" htmlFor="rejection-reason">
                    Reason for rejection <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <textarea
                    id="rejection-reason"
                    data-testid="rejection-reason-textarea"
                    className="form-control"
                    rows={4}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Explain what needs to be corrected so the user can update and resubmit."
                    disabled={loading}
                />
                {item?.FullName && (
                    <div className="text-muted small mt-2">
                        Rejecting: <strong>{item.FullName}</strong>{item.Email ? ` (${item.Email})` : ''}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    className="cus-primary-transparent-btn"
                    onClick={onCancel}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    className="cus-primary-bg-btn"
                    onClick={handleConfirm}
                    disabled={!canSubmit}
                >
                    {loading ? 'Rejecting...' : 'Reject'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

RejectReasonModal.propTypes = {
    show: PropTypes.bool,
    item: PropTypes.shape({
        Id: PropTypes.number,
        FullName: PropTypes.string,
        Email: PropTypes.string,
        RejectionReason: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

RejectReasonModal.defaultProps = {
    show: false,
    item: null,
    loading: false,
};

export default RejectReasonModal;
